/* Slider Handler Index */
export enum SliderHandlerEnum {
  left = 0,
  right = 1,
}
